import React from "react";

interface FavFilterPanelProps {
  selectedAddressType: string;
  setSelectedAddressType: React.Dispatch<React.SetStateAction<string>>;

  selectedPinned: string;
  setSelectedPinned: React.Dispatch<React.SetStateAction<string>>;

  filterSearch: string;
  setFilterSearch: React.Dispatch<React.SetStateAction<string>>;

  sortOrder: string;
  setSortOrder: React.Dispatch<React.SetStateAction<string>>;

  onClose: () => void;
}

const FavFilterPanel: React.FC<FavFilterPanelProps> = ({
  selectedAddressType,
  setSelectedAddressType,
  selectedPinned,
  setSelectedPinned,
  filterSearch,
  setFilterSearch,
  sortOrder,
  setSortOrder,
  onClose,
}) => {
  const resetFilter = () => {
    setSelectedAddressType("");
    setSelectedPinned("");
    setFilterSearch("");
    setSortOrder("");
  };

  const handleApply = () => {
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-50 z-[1000]"
        onClick={onClose}
      />

      {/* Panel */}
      <div className="absolute lg:w-2/5 z-[2000] right-0 p-4 border mt-2 rounded-md mr-8 bg-white shadow-md">
        {/* Address Type */}
        <div className="mb-4">
          <label className="block mb-2 font-semibold">
            Filter Address Type
          </label>

          <div className="flex flex-wrap gap-4">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="addressType"
                checked={selectedAddressType === "Home"}
                onChange={() => setSelectedAddressType("Home")}
              />
              <span>Home</span>
            </label>

            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="addressType"
                checked={selectedAddressType === "Office"}
                onChange={() => setSelectedAddressType("Office")}
              />
              <span>Office</span>
            </label>

            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="addressType"
                checked={selectedAddressType === "Other"}
                onChange={() => setSelectedAddressType("Other")}
              />
              <span>Other</span>
            </label>
          </div>
        </div>

        {/* Pin Status */}
        <div className="mb-4">
          <label className="block mb-2 font-semibold">
            Pin Status
          </label>

          <div className="flex gap-4">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="pinStatus"
                checked={selectedPinned === "Pinned"}
                onChange={() => setSelectedPinned("Pinned")}
              />
              <span>Pinned</span>
            </label>

            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="pinStatus"
                checked={selectedPinned === "Unpinned"}
                onChange={() => setSelectedPinned("Unpinned")}
              />
              <span>Unpinned</span>
            </label>
          </div>
        </div>

        {/* Sort */}
        <div className="mb-4 flex items-center justify-between">
          <span className="font-semibold">Sort By</span>

          <div className="flex rounded-lg border border-blue-600 overflow-hidden">
            <button
              type="button"
              onClick={() => setSortOrder("az")}
              className={`px-6 py-2 text-sm font-medium transition-all ${
                sortOrder === "az"
                  ? "bg-blue-600 text-white"
                  : "bg-white text-blue-600 hover:bg-blue-50"
              }`}
            >
              A-Z
            </button>

            <button
              type="button"
              onClick={() => setSortOrder("za")}
              className={`px-6 py-2 text-sm font-medium border-l border-blue-600 transition-all ${
                sortOrder === "za"
                  ? "bg-blue-600 text-white"
                  : "bg-white text-blue-600 hover:bg-blue-50"
              }`}
            >
              Z-A
            </button>
          </div>
        </div>

        {/* Search */}
        <div className="mb-4">
          <label className="block mb-1 font-semibold">
            Search Keyword
          </label>

          <input
            type="text"
            value={filterSearch}
            onChange={(e) => setFilterSearch(e.target.value)}
            className="w-full p-2 border rounded-md"
            placeholder="Search here..."
          />
        </div>

        {/* Buttons */}
        <div className="flex gap-2 justify-between">
          <button
            onClick={resetFilter}
            className="px-4 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500"
          >
            Reset
          </button>

          <button
            onClick={handleApply}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Apply
          </button>
        </div>
      </div>
    </>
  );
};

export default FavFilterPanel;